import { useEffect, useRef } from "react";
import "./BlueVeliaBtn.css";

function BlueVeliaBtn() {
  const btnRef = useRef(null);

  useEffect(() => {
    const btn = btnRef.current;
    if (!btn) return;

    const handleMouseMove = (e) => {
      const rect = btn.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      btn.style.setProperty("--mx", `${x}%`);
      btn.style.setProperty("--my", `${y}%`);
    };

    btn.addEventListener("mousemove", handleMouseMove);
    return () => btn.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="bluveliaBtn">
        <a
        href="https://bluevelia.com"
        target="_blank"
        rel="noopener noreferrer"
        className="bv-btn"
        ref={btnRef}
        >
        <span className="bv-btn__glow" />
        <span className="bv-btn__border" />
        <span className="bv-btn__content">
            <span className="bv-btn__dot" />
            <span className="bv-btn__text">Découvrir mes services</span>
            <span className="bv-btn__arrow">↗</span>
        </span>
        </a>
    </div>
    
  );
}

export default BlueVeliaBtn;